import http from "./http-common";

// ยอดเข้าชมเว็บไซต์ (แสดงตรง footer)
//
// นับเป็น "session" ตามนิยามของ Google Analytics: เข้ามาใช้เว็บ 1 รอบ = 1 ครั้ง
// และถือว่าเป็นรอบใหม่เมื่อไม่มีการใช้งานติดต่อกันเกิน 30 นาที
// (นับจากการเปลี่ยนหน้าล่าสุด ไม่ใช่จากตอนเข้ามาครั้งแรก)
const HIT_KEY = "hcu_visit_at";
const HIT_WINDOW_MS = 30 * 60 * 1000;

/** ยังอยู่ใน session เดิมไหม — localStorage ใช้ไม่ได้ให้ถือว่าไม่อยู่ */
function alreadyCounted() {
  try {
    const at = Number(localStorage.getItem(HIT_KEY));
    return at && Date.now() - at < HIT_WINDOW_MS;
  } catch {
    return false;
  }
}

function markCounted() {
  try {
    localStorage.setItem(HIT_KEY, String(Date.now()));
  } catch {
    // private mode / storage blocked — ปล่อยผ่าน
  }
}

function unmarkCounted() {
  try {
    localStorage.removeItem(HIT_KEY);
  } catch {
    // ไม่เป็นไร
  }
}

// eslint-disable-next-line
export default new (class VisitService {
  async getCount() {
    return await http
      .get("/site-visit/count")
      .then((response) => Number(response.data.total) || 0)
      .catch((error) => {
        console.log(error);
        return null;
      });
  }

  /** นับเข้าชมถ้าเป็น session ใหม่ แล้วคืนยอดล่าสุด */
  async record() {
    if (alreadyCounted()) {
      // ยังอยู่ใน session เดิม — ต่ออายุอีก 30 นาทีจากการเปลี่ยนหน้าครั้งนี้ (เหมือน GA)
      markCounted();
      return this.getCount();
    }

    // จองไว้ก่อนยิง — footer ถูก mount ใหม่ทุกครั้งที่เปลี่ยนหน้า
    // ถ้าเปลี่ยนหน้าเร็ว ๆ ตอนโหลดครั้งแรกจะได้ไม่นับซ้ำ
    markCounted();

    return await http
      .post("/site-visit/hit")
      .then((response) => Number(response.data.total) || 0)
      .catch((error) => {
        console.log(error);
        unmarkCounted();
        return null;
      });
  }
})();
